module Omni.ResortMap {
    ngModule.directive('floorCanvas', (['$rootScope', '$stateParams', '$state', "Kinetic",
        function ($rootScope, $stateParams, $state, Kinetic) {
            function createShape(x, y, shape, id) {
                var r = 10;
                var el;
                var name = 'Marker ' + (id + 1);
                var shapeId = "shape" + id;

                el = new Kinetic.Circle({
                    x: x,
                    y: y,
                    radius: r,
                    name: name,
                    id: shapeId,
                    fill: '#d55628',
                    stroke: '#b14822',
                    strokeWidth: 1
                });

                return el;
            }

            function createMarkerGroup(point, i, xRatio, yRatio) {
                var x = (point.x_coord / 2) * xRatio;
                var y = (point.y_coord / 2) * yRatio;
                var shape = "default";
                var kids = new Kinetic.Group({
                    id: "group" + i,
                    index: i
                });

                var floorMapMarker = createShape(x, y, shape, i);
                kids.add(floorMapMarker);

                return kids;
            }

            function buildPopover(loc, x, y, el) {
                var width = jQuery("#mapContainer").width();
                var height = jQuery("#mapContainer").height();

                var popover: any = {};
                var v, h;
                if (y > height / 2) {
                    popover.top = y - 168;
                    v = "top";
                } else {
                    popover.top = y + 10;
                    v = "bottom";
                }

                if (x > width / 2) {
                    h = "l";
                    popover.left = x - 212;
                } else {
                    h = "r";
                    popover.left = x - 20;
                }

                jQuery("#popoverElement").css({
                    top: popover.top,
                    left: popover.left
                });

                popover.placement = v + ' ' + h;
                popover.type = 'floor';
                popover.title = loc.title;
                popover.area = loc.area;
                popover.capacity = loc.capacity;
                popover.l = loc.length;
                popover.w = loc.width;

                if ((loc.length != null && loc.length != 0) && (loc.width != null && loc.width != 0)) {
                    popover.dimensions = loc.length + "' x " + loc.width + "'";
                } else {
                    popover.dimensions = "NA";
                }
                popover.ceiling = loc.ceiling;
                popover.el = el;

                return popover;
            }

            return {
                restrict: "E",
                priority: 1001,
                template: '<div id="floorMapCanvas" style="background: url(\'{{ floor_img }}\') no-repeat top left;background-size:contain;"></div>',
                replace: true,
                link: function (scope, element, attrs) {
                    var imageObj = new Image();
                    imageObj.src = attrs.src;
                    scope.floor_img = attrs.src;
                    // jQuery("#floorMapCanvas").css("background", "no-repeat top left").css("backgroundImage", scope.floor_img);
                    var mainContainer = jQuery("#mainMapContainer");

                    var containerWidth = mainContainer.width() * (3 / 4);
                    jQuery("#floorMapCanvas").width(containerWidth);

                    var containerHeight = containerWidth * 430 / 692;
                    jQuery("#floorMapCanvas").height(containerHeight);
                    jQuery("#mainMapContainer").height((containerHeight + 2));

                    var xRatio = containerWidth / 692;
                    var yRatio = containerHeight / 430;

                    var floorMap: any = {
                        canvasId: element.attr('id'),
                        stage: null,
                        layer: null,
                        points: null,
                        popover: null,

                        initialize: function () {
                            floorMap.points = scope.floor.room;
                            floorMap.stage = new Kinetic.Stage({
                                container: floorMap.canvasId,
                                width: containerWidth,
                                height: containerHeight
                            });
                            var floor = new Kinetic.Image({
                                x: 0,
                                y: 0,
                                image: imageObj,
                                width: containerWidth,
                                height: containerHeight
                            });

                            floorMap.layer = new Kinetic.Layer();
                            // floorMap.layer.add(floor);

                            for (var i = 0; i < floorMap.points.length; i++) {

                                var kids = createMarkerGroup(floorMap.points[i], i, xRatio, yRatio);
                                // add handler to fire tweening function
                                kids.on("tap", function (e) {
                                    var target = (angular.isUndefined(e.target.parent)) ?
                                        e.target : e.target.parent.attrs.index;
                                    floorMap.showPopover(target);
                                });
                                kids.on("click", function (e) {
                                    var target = (angular.isUndefined(e.target.parent)) ?
                                        e.target : e.target.parent.attrs.index;
                                    floorMap.showPopover(target);
                                });

                                floorMap.layer.add(kids);
                            }

                            floorMap.stage.add(floorMap.layer);
                            floorMap.stage.on("click", function (evt) {
                                // console.log(evt);
                            });

                            jQuery("#roomPopoverSelect").empty().append('<option value="-1">Select Room</option>');
                            angular.forEach(scope.floor.room, function (el: any, index) {
                                var option = '<option value="' + index + '">' + el.name + '</option>'
                                jQuery("#roomPopoverSelect").append(option);
                                option = "";
                            });
                            jQuery("#roomPopoverSelect").off();
                            jQuery("#roomPopoverSelect").on("change", function (e) {
                                var i = this.value;
                                floorMap.showPopover(i);
                            });
                        },
                        showPopover: function (target, i) {
                            var floor = scope.location.floor[$stateParams["floorId"]];
                            if (target == -1) {
                                scope.showPopover = false;
                                scope.$apply();
                                return;
                            }
                            var groupName = "#group" + (target);
                            var shape = floorMap.stage.find(groupName);
                            var coordx = shape[0].children[0].attrs.x;
                            var coordy = shape[0].children[0].attrs.y;

                            var loc = null;
                            loc = floor.room[target];
                            scope.showPopover = false;
                            scope.popover = buildPopover(loc, (coordx), (coordy), target);
                            scope.showPopover = true;
                            loc = null;
                            scope.$apply();
                        }
                    };

                    imageObj.onload = function () {
                        scope.$apply(floorMap.initialize());

                        $rootScope.$on("closePopover", function () {
                            scope.showPopover = false;
                        });

                    };
                }
            };
        }]) as any);
}
